'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { markInAppNavigation } from '@website/hooks/useBackNavigation';

/**
 * Records each client-side route change so the app knows when there is a real
 * in-app page behind the user (see {@link useBackNavigation}). Mounted once in
 * the locale layout; renders nothing.
 *
 * The very first pathname is the page the tab loaded on (a deep link, when the
 * user arrives from an external source) and must NOT count as in-app history —
 * only subsequent navigations do.
 */
export function NavigationHistoryTracker() {
  const pathname = usePathname();
  const isInitial = useRef(true);

  useEffect(() => {
    if (isInitial.current) {
      isInitial.current = false;
      return;
    }
    markInAppNavigation();
  }, [pathname]);

  return null;
}
